import React from 'react'
import { translate } from 'react-i18next'
import { Link } from 'react-router-dom'
import './index.sass'

const getCorrectLanguageName = (lang) =>{
    const transformedLanguageName =  lang.split('-').map(item=>{
        return (item.charAt(0).toUpperCase() + item.substring(1))
    }).join(' ')
    return transformedLanguageName
}

const getCrumb = (path, t) => {
    switch(path) {
        case 'about':
        return t('navigations.about')
        case 'blog':
        return t('home.foreigns.blog.title')
        case 'all-languages':
        return t('home.foreigns.allLanguages.subtitle')
        case 'voices':
        return t('navigations.voices')
        case 'portfolio':
        return t('navigations.portfolio')
        case 'showreels':
        return t('portfolio.links.showreels')
        case 'cases':
        return t('portfolio.links.cases')
        case 'prices':
        return t('navigations.prices')
        case 'reviews':
        return t('navigations.reviews')
        case 'chronometer':
        return t('navigations.chronometer')
        case 'contacts':
        return t('navigations.contacts')
        case 'payments':
        return t('navigations.payments')
        case 'services':
        return t('navigations.services')
        case 'voice-over':
        return t('services.voice-over')
        case 'video-localization':
        return t('services.video-localization')
        case 'gaming':
        return t('services.gaming')
        case 'mobile-apps':
        return t('services.mobile-apps')
        case 'audioguides':
        return t('services.audioguides')
        case 'audiobooks':
        return t('services.audiobooks')
        case 'navigations':
        return t('services.navigations')
        case 'radio-spots':
        return t('services.radio-spots')
        case 'telephone-messages':
        return t('services.telephone-messages')
        case 'tts-projects':
        return t('services.tts-projects')
        case 'translating':
        return t('services.translating')
        case 'proofreading':
        return t('services.proofreading')
        case 'graphic-elements-replacing':
        return t('services.graphic-elements-replacing')
        case 'length-adaptation':
        return t('services.length-adaptation')
        case 'e-learning':
        return t('services.e-learning')
        case 'presentations':
        return t('services.presentations')
        case 'documentaries':
        return t('services.documentaries')
        case 'advertising':
        return t('services.advertising')
        case 'trailers':
        return t('services.trailers')
        case 'cutting':
        return t('services.cutting')
        case 'dubbing':
        return t('services.dubbing')
        case 'subtitling':
        return t('services.subtitling')
        default:
            return t(`Language.${getCorrectLanguageName(path)}`)
    }
}

const getLinkForCrumb = (index, path) => {
    let formattedPath = [...path]
    if(path[0] === 'ru' || path[0] === 'de') {
        formattedPath.shift()
    }
   const link = formattedPath.slice(0,path[0] === 'ru' || path[0] === 'de' ? index : index+1).join('/')
   return link
}

const Breadcrumbs = (props) => {
    const {t, lng, pathname, color = 'black'} = props
    const path = lng === 'en' ? '' : `/${lng}`
    const splittedPath = pathname.split('/').slice(1)
    return (
        <div className='crumbs'>
            <Link
                style={{color: color}}
                to={`${path.toLowerCase().split(' ')}`}
            >
                <div className='crumbItem'>{t('navigations.home')}</div>
            </Link>
            <div>/</div>
            {splittedPath.map((crumb, index)=>{
                if (crumb!=='ru' && crumb !=='de'){
                    return (
                        <>
                        { splittedPath.length - 1 !== index ?
                            <Link
                        key={crumb}
                        style={{color: color}}
                        to={`${path.toLowerCase().split(' ').join('-')}/${getLinkForCrumb(index,splittedPath)}`}
                        >
                            <div key={crumb} className='crumbItem'>
                                {getCrumb(crumb,t).charAt(0).toUpperCase() + getCrumb(crumb,t).substring(1)}
                            </div>
                        </Link> :
                        <div key={crumb} className='crumbItem'>
                            {getCrumb(crumb,t).charAt(0).toUpperCase() + getCrumb(crumb,t).substring(1)}
                        </div>
                        }
                        { splittedPath.length - 1 !== index &&
                        <div>/</div>
                        }
                        </>
                        )
                }
                
        })}
        </div>
    )
}
  


export default translate('translations')(Breadcrumbs)